import React, { useContext, useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Container, Card, Button, Form , Col, Row, } from 'react-bootstrap';

import carSales from '../../../images/hotel.png'

import car from '../../../images/car.png'
import airplane from '../../../images/airplane-col.png'
import location from '../../../images/location-col.png'
import calendar from '../../../images/calendar-2.png'
import Clock from '../../../images/clock.png'
import { locations, carPickUpTime, carClasses, carTypes } from '../../../data';
import AppContext from '../../../AppContext';



const CarRentals = () => {
  const{carClass, setCarClass, carType, setCarType, carLocation, setCarLocation, pickUpDate, setPickUpDate, pickUpTime, setPickUpTime,daysNo, setDaysNo} = useContext(AppContext);
  const [showDatePicker, setShowDatePicker] = useState(false);
 
 const navigate= useNavigate();
 const [isFormValid, setIsFormValid] = useState(false);
 useEffect(() => {
  validateForm();
}, [carClass, carType, carLocation, pickUpDate, pickUpTime, daysNo]);
useEffect(()=>{
  setCarClass('');
   setCarType(''); setCarLocation('');
   setPickUpDate(new Date()); setPickUpTime(''); setDaysNo('');
},[])

 const handleDateClick = () => {
  setShowDatePicker(true);
};


  const formatDateToWords = (date) => {
    const options = {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    };
    return date.toLocaleDateString(undefined, options);
  };
const handleDateChange = (date) => {
 setPickUpDate(date);
  setShowDatePicker(false);
 
};
const handleCarClassChange = (event) => {
  setCarClass(event.target.value);
 
 
};
const handleCarTypeChange = (event) => {
  setCarType(event.target.value);
 
 
};
const handleCarLocationChange = (event) => {
  setCarLocation(event.target.value);
 

};
const handleDaysNoChange = (event) => {
  setDaysNo(event.target.value);
 
 
};

const handlePickUpTimeChange = (event) => {
  setPickUpTime(event.target.value);
  
 
};
// const validateForm = () => {
//       setIsFormValid(carLocation !== '' && pickUpTime !== '' && carType !== '' && carClass !== '' && daysNo !== '' && pickUpDate !== ''  );
//     };

const validateForm = ()=> {
  setIsFormValid(carClass !== '' && carType !== '' && carLocation !== '' && pickUpDate !== '' && pickUpTime !== '' && daysNo !== '')
}

const handleCarSubmit = (event) => {
  event.preventDefault();

  if (isFormValid) {
    navigate('/available-cars');
  }

};

  return (
    <div>
     
    
         
          <Card className='border-0 bg-white all-container d-none d-sm-block' >
          <Card.Img src={carSales} alt='carsales' style={{maxHeight:'500px'}} className='d-none d-sm-block'/>
          <Card.ImgOverlay className='p-3 p-md-5 mt-md-5 '>
        <div className='p-lg-5 mt-lg-5 ' >
          <div className='d-flex gap-4 px-sm-4 py-4 bg-white '>
            <button className='booking-button'><img src={car} alt='car'/>
              Car Rentals
              </button>
            </div>
            <div className=''>
              
              
                  <Card style={{background: '#008080', borderRadius: 'none'}} className='p-5 border-0'>
                      <Form onSubmit={handleCarSubmit}>
                  <div className='d-block d-sm-flex gap-2'>
                  <Form.Select className='mb-2 p-2 flight-select' value={carClass}  onChange={handleCarClassChange}  isValid={carClass !== ''}
          isInvalid={carClass === ''}>
                  <option value=''>Car Class</option>
                  {carClasses.map((carClass) => (
                          <option key={carClass} value={carClass}>{carClass}</option>
                      ))}
  
                  </Form.Select>
                  <Form.Select className='mb-2 p-2 flight-select'  value={carType}  onChange={handleCarTypeChange}  isValid={carType !== ''}
          isInvalid={carType === ''}>
                  <option value=''> Car type</option>
                  {carTypes.map((carType) => (
                          <option key={carType} value={carType}>{carType}</option>
                      ))}
                  </Form.Select>
                 
                  
                  
                  </div>
                  <Row className='mt-3 g-2'>
                     
                      <Col xs={12} sm={6} md={6} lg={3}> <div className='d-flex gap-2 p-2 align-items-center locate' style={{ background:'#fff'}}>
                          <img src={car} alt='car' style={{width:'30px', height:'30px'}}/>
                          <div>
                              <p className='pe-3'>From ?</p>
                              <Form.Select className='border-0'value={carLocation}  onChange={handleCarLocationChange}  isValid={carLocation !== ''}
          isInvalid={carLocation === ''} >
             <option value=''>Current Location</option>
             
             {locations.map((location) => (
          <option key={location} value={location}>
            {location}, Nigeria
          </option>
          ))}
              </Form.Select>
                             
                          </div>
  </div>                       </Col>
                      <Col xs={12} sm={6} md={6} lg={3}> <div className='d-flex gap-2 p-2 align-items-center locate' style={{ background:'#fff'}}>
                          <img src={calendar} alt='calendar' style={{width:'30px', height:'30px'}}/>
                          <div>
                              <p className='pe-2'>Pick-up date</p>
                              <Form.Group>                           <Form.Control type="text"
                              value={formatDateToWords(pickUpDate)}
                              onClick={handleDateClick}
                              readOnly className='border-0' isValid={pickUpDate !== ''}
                              isInvalid={pickUpDate === ''}/>
                              {showDatePicker && (
                              <ReactDatePicker
                                selected={pickUpDate}
                                onChange={handleDateChange}
                                dateFormat="MM/dd/yyyy"
                                onClickOutside={() => setShowDatePicker(false)}  
      /> )}
    
                       </Form.Group>  
                            
                             
                          </div>
  </div>                       </Col>
                      <Col xs={12} sm={6} md={6} lg={3} > <div className='d-flex gap-2 p-2 align-items-center locate' style={{ background:'#fff'}}>
                          <img src={Clock} alt='clock' style={{width:'30px', height:'30px'}}/>
                          <div>
                              <p className='pe-3'>Pick-up time</p>
                        <Form.Select className='border-0'value={pickUpTime}  onChange={handlePickUpTimeChange} isValid={pickUpTime !== ''} isInvalid={pickUpTime === ''}>     <option>Select Pick-up Time</option>
                              {carPickUpTime.map((pickup)=>
                                (
          <option key={pickup} value={pickup}>
            {pickup}
          </option>
                              ))}
            
        </Form.Select>
                       
                             
                          </div>
  </div>                        </Col>
  <Col xs={12} sm={6} md={6} lg={3}> <div className='d-flex gap-2 p-2 align-items-center locate' style={{ background:'#fff'}}>
  <img src={Clock} alt='clock' style={{width:'30px', height:'30px'}}/>
                          <div>
                              <p className='pe-3'>Number of Days?</p>
                              <Form.Select className='border-0' value={daysNo}  onChange={handleDaysNoChange} isValid={daysNo !== ''} isInvalid={daysNo === ''} >
                              <option>Days</option>
                              <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
        <option value="4">4</option>
        <option value="5">5</option>
        <option value="6">6</option>
        <option value="7">7</option>
              </Form.Select>
                             
                          </div>
  </div>                       </Col>
 
                  </Row>
                  <div className='mt-5 text-center'>
                  <button type='submit' disabled={!isFormValid}  className='subscribe-button border-0' style={{width:'250px'}}>Search for cars</button>
                  </div>
                  </Form>
              </Card>
            
            </div>
          </div>
        
      </Card.ImgOverlay>
          </Card>
          <div className='p-3 mb-5 d-block d-sm-none'>
          <div className='p-lg-5 mt-lg-5 ' >
          <div className='d-flex gap-4 px-sm-4 py-4 bg-white '>
            <button className='booking-button'><img src={car} alt='car'/>
              Car Rentals
              </button>
            </div>
            <div className=''>
              
              
                  <Card style={{background: '#008080', borderRadius: 'none'}} className='p-5 border-0'>
                      <Form onSubmit={handleCarSubmit}>
                  <div className='d-block d-sm-flex gap-2'>
                  <Form.Select className='mb-2 p-2 flight-select' value={carClass}  onChange={handleCarClassChange}  isValid={carClass !== ''}
          isInvalid={carClass === ''}>
                  <option value=''>Car Class</option>
                  {carClasses.map((carClass) => (
                          <option key={carClass} value={carClass}>{carClass}</option>
                      ))}
  
                  </Form.Select>
                  <Form.Select className='mb-2 p-2 flight-select'  value={carType}  onChange={handleCarTypeChange}  isValid={carType !== ''}
          isInvalid={carType === ''}>
                  <option value=''> Car type</option>
                  {carTypes.map((carType) => (
                          <option key={carType} value={carType}>{carType}</option>
                      ))}
                  </Form.Select>
                 
                  
                  
                  </div>
                  <Row className='mt-3 g-2'>
                     
                      <Col xs={12} sm={6} md={6} lg={3}> <div className='d-flex gap-2 p-2 align-items-center locate' style={{ background:'#fff'}}>
                          <img src={car} alt='car' style={{width:'30px', height:'30px'}}/>
                          <div>
                              <p className='pe-3'>From ?</p>
                              <Form.Select className='border-0'value={carLocation}  onChange={handleCarLocationChange}  isValid={carLocation !== ''}
          isInvalid={carLocation === ''} >
             <option value=''>Current Location</option>
             
             {locations.map((location) => (
          <option key={location} value={location}>
            {location}, Nigeria
          </option>
          ))}
              </Form.Select>
                             
                          </div>
  </div>                       </Col>
                      <Col xs={12} sm={6} md={6} lg={3}> <div className='d-flex gap-2 p-2 align-items-center locate' style={{ background:'#fff'}}>
                          <img src={calendar} alt='calendar' style={{width:'30px', height:'30px'}}/>
                          <div>
                              <p className='pe-2'>Pick-up date</p>
                              <Form.Group>                           <Form.Control type="text"
                              value={formatDateToWords(pickUpDate)}
                              onClick={handleDateClick}
                              readOnly className='border-0' isValid={pickUpDate !== ''}
                              isInvalid={pickUpDate === ''}/>
                              {showDatePicker && (
                              <ReactDatePicker
                                selected={pickUpDate}
                                onChange={handleDateChange}
                                dateFormat="MM/dd/yyyy"
                                onClickOutside={() => setShowDatePicker(false)}  
      /> )}
    
                       </Form.Group>  
                            
                             
                          </div>
  </div>                       </Col>
                      <Col xs={12} sm={6} md={6} lg={3} > <div className='d-flex gap-2 p-2 align-items-center locate' style={{ background:'#fff'}}>
                          <img src={Clock} alt='clock' style={{width:'30px', height:'30px'}}/>
                          <div>
                              <p className='pe-3'>Pick-up time</p>
                        <Form.Select className='border-0'value={pickUpTime}  onChange={handlePickUpTimeChange} isValid={pickUpTime !== ''} isInvalid={pickUpTime === ''}>     <option>Select Pick-up Time</option>
                              {carPickUpTime.map((pickup)=>
                                (
          <option key={pickup} value={pickup}>
            {pickup}
          </option>
                              ))}
            
        </Form.Select>
                       
                             
                          </div>
  </div>                        </Col>
  <Col xs={12} sm={6} md={6} lg={3}> <div className='d-flex gap-2 p-2 align-items-center locate' style={{ background:'#fff'}}>
  <img src={Clock} alt='clock' style={{width:'30px', height:'30px'}}/>
                          <div>
                              <p className='pe-3'>Number of Days?</p>
                              <Form.Select className='border-0' value={daysNo}  onChange={handleDaysNoChange} isValid={daysNo !== ''} isInvalid={daysNo === ''} >
                              <option>Days</option>
                              <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
        <option value="4">4</option>
        <option value="5">5</option>
        <option value="6">6</option>
        <option value="7">7</option>
              </Form.Select>
                             
                          </div>
  </div>                       </Col>
 
                  </Row>
                  <div className='mt-5 text-center'>
                  <button type='submit' disabled={!isFormValid}  className='subscribe-button border-0' style={{width:'250px'}}>Search for cars</button>
                  </div>
                  </Form>
              </Card>
            
            </div>
          </div>
          </div>
     
      </div>
  )
}

export default CarRentals
